import { RootState } from 'store';

export const isLoading = (state: RootState) => state.positions.loading;
export const positionOptions = (state: RootState) => state.positions.positions;
